export default __webpack_public_path__ + "static/media/menuClose.cc3b0830.svg";